import { Model } from '#/graphql/types';
import { Key } from '#/types';

export const updateMutationFields: Key<Model>[] = [
  'name',
  'manufacturerId',
  'assetTypeId',
  'oemPartNumber',
  'usefulLife',
  'probability',
  'severity',
  'specification',
  'tenantId',
  'inUseStatus'
];

export const createMutationFields: Key<Model>[] = [
  'name',
  'manufacturerId',
  'tenantId',
  'assetTypeId',
  'oemPartNumber',
  'usefulLife',
  'inUseStatus',
  'probability',
  'severity',
  'specification',
];
